import React from "react";
import { Button } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

import cls from "./FilterRoot.module.less";

interface FilterActionsProps {
  resetForm?: () => void;
}

export const FilterActions = (props: FilterActionsProps) => {
  const { t } = useTranslation();

  return (
    <div className={cls.FilterActions}>
      {props?.resetForm && (
        <Button
          onClick={props.resetForm}
          size={"middle"}
          color={"secondary"}
          variant={"text"}
        >
          {t("ui.filter_reset")}
        </Button>
      )}
      <Button size={"middle"} color={"secondary"} htmlType={"submit"}>
        {t("ui.filter_show")}
      </Button>
    </div>
  );
};
